import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterComponent } from '@ui/table-modifier/filters';
import React from 'react';
import { TextFilter } from '@ui/table-modifier/filters/Text';

export const ActionFilter: FilterComponent<string | undefined> = (props) =>
	<TextFilter
		placeholder={ COPY_SPECIFIC.SEARCH_ACTIONS }
		{ ...props } />;

